var image_viewer_rtlignore_default = {
  "fontElementMap": "_4Da--",
  "imageContainer": "DWFDm",
  "expandButton": "nN-y2",
  "expandIcon": "jf9ju",
  "pointer": "m2wyr",
  "imageWrapper": "_5ke6I",
  "imageRatio": "GvlSj",
  "image": "-lYno",
  "imageOverlay": "paOtJ",
  "imagePreload": "oh7Wg",
  "imageHighres": "M2NWp",
  "onlyHighRes": "_69N0N",
  "image_loading": "UWr-l"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
